import { render } from "./DeviceInTree.vue?vue&type=template&id=23d0e760"
import script from "./DeviceInTree.vue?vue&type=script&lang=js"
export * from "./DeviceInTree.vue?vue&type=script&lang=js"
script.render = render

export default script